import clsx from 'clsx'
import { motion } from 'motion/react'

import type { TutorialHintGroup } from '@/src/stores/TutorialStore'

const SHINE_SRC = '/images/tutorial/shine.png'

type ControlHintShineProps = {
    type: TutorialHintGroup
    className?: string
}

/** Glow shine underneath a control button during tutorial hints. */
export default function ControlHintShine({
    type,
    className,
}: ControlHintShineProps) {
    const isLeft = type === 'left'
    const isRight = type === 'right'
    const isJump = type === 'jump'
    const isSnap = type === 'snap'

    return (
        <motion.img
            src={SHINE_SRC}
            alt=''
            aria-hidden
            draggable={false}
            animate={{ scale: [1, 1.06, 1], opacity: [0.9, 1, 0.9] }}
            transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut',
            }}
            className={clsx(
                'z-0 absolute max-w-none object-contain pointer-events-none select-none mix-blend-screen',
                isSnap &&
                '-bottom-4 right-[50%] translate-x-1/2 -translate-y-1/2 w-28 md:w-32 stele:-bottom-16 stele:right-[50%] stele:w-lg',
                isLeft &&
                '-left-15 bottom-14 translate-x-1/2 translate-y-1/2 w-28 md:w-32 stele:-left-72 stele:bottom-54 stele:w-lg',
                isRight &&
                'bottom-14 -right-15 -translate-x-1/2 translate-y-1/2 w-28 md:w-32 stele:bottom-54 stele:-right-72 stele:w-lg',
                isJump &&
                '-bottom-22 right-[50%] translate-x-1/2 -translate-y-1/2 w-28 md:w-32 stele:-bottom-24 stele:right-[45%] stele:w-lg',
                className,
            )}
        />
    )
}
